export default {
  en: {
    title: 'Vocabulary',
    review: 'Review',
    learn: 'Learn',
  },
  ru: {
    title: 'Словарь',
    review: 'Повторять',
    learn: 'Учить',
  },
};
